<div class="sec-data  ">

    <div class="d-flex justify-content-between align-items-center">
      <h4 class="mt-1 mb-0">Overall Rating</h4>


    </div>
    <div class="d-flex mb-3 align-items-center">
      <!-- Dynamic Rating Stars -->
      <span class="mr-2 mt-2 rateNum">{{overRating?.overAllRating | number: '1.2-2'}}</span>
      <div class="star-rating">
        <!-- Outer gray stars -->
        <div class="stars-outer">
          ★★★★★
          <!-- Inner gold stars with dynamic width -->
          <div class="stars-inner" [style.width]="(overRating?.overAllRating / 5) * 100 + '%'">
            ★★★★★
          </div>
        </div>
      </div>
    </div>

    <p class="rateTxt">Based on {{overRating?.totalNumberOfRating}} Ratings</p>
    <div>
      <div class="d-flex justify-content-between align-items-center" style="gap: 5px;">
        <span style="white-space: nowrap;">5 <span class="star">★</span></span> <p-progressBar
          [value]="overRating?.fiveTotal * 100"></p-progressBar> <span class="w-wrap"> {{overRating?.fiveTotal * 100 | number: '1.2-2' }}
          %</span>
      </div>
      <div class="d-flex justify-content-between align-items-center" style="gap: 5px;">
        <span style="white-space: nowrap;">4 <span class="star">★</span></span> <p-progressBar
          [value]="overRating?.fourTotal * 100"></p-progressBar> <span class="w-wrap"> {{overRating?.fourTotal * 100 | number: '1.2-2' }}
          %</span>
      </div>
      <div class="d-flex justify-content-between align-items-center" style="gap: 5px;">
        <span style="white-space: nowrap;">3 <span class="star">★</span></span> <p-progressBar
          [value]="overRating?.threeTotal * 100"></p-progressBar> <span class="w-wrap">{{overRating?.threeTotal *
          100 | number: '1.2-2' }} %</span>
      </div>
      <div class="d-flex justify-content-between align-items-center" style="gap: 5px;">
        <span style="white-space: nowrap;">2 <span class="star">★</span></span> <p-progressBar
          [value]="overRating?.twoTotal * 100"></p-progressBar> <span class="w-wrap">{{overRating?.twoTotal * 100 | number: '1.2-2' }}
          %</span>
      </div>
      <div class="d-flex justify-content-between align-items-center" style="gap: 5px;">
        <span style="padding-left: 4px;white-space: nowrap;">1 <span class="star">★</span></span> <p-progressBar
          [value]="overRating?.oneTotal * 100"></p-progressBar> <span class="w-wrap"> {{overRating?.oneTotal * 100 | number: '1.2-2' }}
          %</span>
      </div>
    </div>

  </div>
